var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-2 flex items-center"},[_c('div',[_c('div',{staticClass:"viewing",class:[
        _vm.video.viewing_percentage === 100 ? _vm.viewingFull : _vm.viewingNormal ]},[_vm._v(" Visto "+_vm._s(_vm.video.viewing_percentage)+" % ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }